import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useModal } from '../../hooks/useModal';

const HeroSection: React.FC = () => {
  const { openUserTypeModal } = useModal();

  const highlights = [
    "Photographer", "Venue", "Planner", "Catering Team", "Videographer",
    "Decorator", "DJ", "Promoter", "Makeup Artist", "Marketer",
    "Video Editor", "Party Starter", "Sound Engineer",
    "Project Manager", "Dancing Crew", "Designer", "Speaker", "Clown"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const fadeDelay = 1000;   // Time for fade in/out effect
    const displayDuration = 2000;  // Time to show the word before fading out

    const timer = setTimeout(() => {
      setIsFading(true);

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % highlights.length);
        setIsFading(false);
      }, fadeDelay);
    }, displayDuration);

    return () => clearTimeout(timer);
  }, [currentIndex, highlights.length]);

  return (
    <div
      className="background-container"
      style={{
        backgroundImage: 'url(/assets/images/Vector.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <Container className="text-center mb-5" id="home">
        <div className="highlight-container">
          <h1>
            <span className="position-relative">
              <span className="position-absolute top-100 start-50 translate-middle">
                <img src="/assets/images/Shape.png" width="144" id="shapeImg" alt="Shape" />
              </span>
              Hire
            </span>
            a <br />
            <span id="highlighted-text" className={`fade-text text-whatshot ${isFading ? 'fade-out' : 'fade-in'}`}>
              {highlights[currentIndex]}
            </span>
          </h1>
        </div>
        <h1 className="display-2">For Your Next Event</h1>
        <p className="subHeroDesktop">
          Effortlessly manage your events from start to finish with our event<br />
          service marketplace. Join as an organizer, freelancer, or vendor.
        </p>
        <p className="subHeroPmobile">
          Effortlessly manage your events from start to finish with our event service marketplace.<br />
          Join as an organizer, freelancer, or vendor.
        </p>
        <button className="main-button" onClick={openUserTypeModal}>
          Join the Waitlist
        </button>
        <p className="freeJoin">(It is free to join)</p>
      </Container>

      <Container className="deskMobImg">
        <Row className="justify-content-center">
          <Col xs={12} className="p-lg-5 pt-lg-0 d-inline-flex justify-content-center ms-5">
            <div className="card bg-transparent position-relative">
              <span className="position-absolute translate-middle" style={{ top: '-4%', left: '-3%' }}>
                <img src="/assets/images/Star.png" width="60" className="starImg" alt="Star" />
              </span>
              <img src="/assets/images/WhatsDesign/image 22.png" className="card-img-top" alt="Design 1" />
            </div>
            <div className="card bg-transparent" style={{ right: '11%' }}>
              <img src="/assets/images/WhatsDesign/image 24.png" className="card-img-top" alt="Design 2" />
              <span className="position-absolute translate-middle top-100 start-100">
                <img src="/assets/images/Star.png" width="60" className="starImg" alt="Star" />
              </span>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
